/*
 *@Description: 布控管理-表格列配置
 *@Author: zhengff
 *@Date: 2019-04-26 21:55:36
*/
import {Dic} from '$utils'
import {Validate} from '$utils'
import i18n from '@src/common/lib/i18n'
const checkControlName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('carPatrol.placeholder.name')));
  }
  if (value.length < 1 || value.length > 50) {
    return callback(new Error(i18n.t('carPatrol.placeholder.length')));
  }
  if (!Validate.validateNames(value)) {
    return callback(new Error(i18n.t('carPatrol.placeholder.nameIno')))
  }
  callback();
};

export const optionForm =()=>{
  return [
  {
    label: i18n.t('carPatrol.label.name'),
    prop: 'controlName',
    span: 24,
    clearable: true,
    rules: [
      { required: true, message: i18n.t('carPatrol.message.name'), trigger: 'blur' },
      {validator: checkControlName, trigger: 'blur'}
    ],
    placeholder: i18n.t('carPatrol.placeholder.name')
  },
  {
    label: i18n.t('carPatrol.label.blacklist'),
    prop: 'blackGroup',
    formslot:true,
    span: 24,
    rules: [
       { required: true, message: i18n.t('carPatrol.message.blacklistName'), trigger: 'change' }
    ],
    clearable: true
  },
  {
    label: i18n.t('carPatrol.label.timeQuantum'),
    prop: 'timeList',
    formslot: true,
    span: 24,
    rules: [
      { required: true, message: i18n.t('carPatrol.message.timeQuantum'), trigger: 'change' }
    ],
    clearable: true
  },
  // {
  //   label: '级别',
  //   prop: 'alarmLevel',
  //   align:'right',
  //   type: 'select',
  //   span: 24,
  //   placeholder: '请选择布控级别',
  //   dicData: Dic.find('SENU017'),
  //   clearable: true,
  //   rules: [
  //     { required: true, message: '请选择布控级别', trigger: 'change' }
  //   ]
  // }
]
}